/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Calvin Kinateder",
  title: "Hi, I'm Calvin Kinateder'",
  subTitle: emoji(
    "🚀 I'm a computer science student and full stack developer looking for a full-time co-op where I can continue to broaden my understanding of software development and apply my skills to make a positive difference in the company."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1JzRz3sQi-Hgn4gQ5ineDcVIFbWOvGFRQ/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ckinateder",
  linkedin: "https://www.linkedin.com/in/calvin-kinateder/",
  gmail: "calvinkinateder@gmail.com",
  medium: "https://medium.com/@calvinkinateder",
  // Instagram and Twitter are also supported in the links!
  //instagram: "https://www.instagram.com/calvin.kinateder/",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "SOFTWARE DEVELOPER AND COMPUTER SCIENCE STUDENT CREATING INNOVATIVE PROJECTS TO BETTER THE WORLD",
  skills: [
    emoji(
      "⚡ Develop highly efficient backend applications for a variety of different use cases"
    ),
    emoji("⚡ ML price-prediction with high-speed algo-trading"),
    emoji(
      "⚡ Mathematical simulation with platforms such as C++, Python, and MATLAB"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "fas fa-copyright"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "MATLAB",
      fontAwesomeClassname: "fas fa-chart-pie"
    },
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Cincinnati",
      logo: require("./assets/images/UClogo.png"),
      subHeader: "Bachelor of Science in Aerospace Engineering",
      duration: "August 2020 - April 2025",
      desc: "Currently a freshman in the College of Engineering and Applied Sciences.",
      descBullets: [
        "Dean's List",
      ]
    },

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Application Design",
      progressPercentage: "80%"
    },
    {
      Stack: "C++",
      progressPercentage: "75%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Computer Engineer Intern",
      company: "Skyward, LTD.",
      companylogo: require("./assets/images/teal.png"),
      date: "May 2021 – August 2021",
      desc:
        "Implemented real-time inference for anomaly detection on incoming aircraft transmissions using C++, TensorRT, and Tensorflow",
      descBullets: [
        "Examined existing codebase and added vital bug fixes, functionality, test cases, and documentation",
        "Accelerated product components for embedded systems by porting from Python to C++",
        "Wrote binary decoders in Golang in concordance with provided specifications",
        "Maximized application portability and long-term support with Docker containerization"        
      ]
    }, 
    {
      role: "STEM Tutor",
      company: "Self-employed",
      companylogo: require("./assets/images/lav.png"),
      date: "January 2021 – April 2021",
      desc:
        "Provided in-person instruction on STEM topics including but not limited to:",
      descBullets: [
        "Python",
        "C++",
        "MATLAB",
        "Calculus"
      ]
    },
    {
      role: "Software Development Intern",
      company: "CoverMyMeds",
      companylogo: require("./assets/images/orange.png"),
      date: "June 2019 – August 2019",
      desc:
        "Developed software closely with others in an agile based environment (SCRUM) and worked along a team to create applications.",
      descBullets: [
        "Designed and implemented software using Ruby on Rails, Python, HTML, CSS, and JavaScript",
        "Managed Git, GitHub, and Docker for version control and carefully documented code",
        "Managed UNIX systems with bash scripting"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME PROJECTS THAT I BUILT",
  projects: [
    {
      image: require("./assets/images/samwise.png"),
      projectName: "SAMWise",
      projectDesc: "Spatial Arbitrage Method Wizard",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ckinateder.github.io/SAMWise/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/pycoin.png"),
      projectName: "PyCoin",
      projectDesc: "Algo-speed-trading with an 85% accurate price prediction algorithm that I designed",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/ckinateder/pycoin/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters",

  achievementsCards: [
    {
      title: "Alpha Lambda Delta Honor Society",
      subtitle:
        "Accepted into Alpha Lambda Delta Honor Society for high-achieving college freshman.",
      image: require("./assets/images/ald.png"),
      footerLink: [
        {
          name: "Alpha Lambda Delta",
          url:
            "https://www.nationalald.org/"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write, record, and teach others what I can share.",

  blogs: [
    {
      url:
        "https://medium.com/@calvinkinateder/dont-fear-vim-a-beginner-s-guide-to-the-world-s-best-editor-part-1-bdd451ae7ce9",
      title: "Don’t Fear Vim — A Beginner’s Guide to the World’s Best Editor (Part 1)",
      description:
        "Vim is the most versatile and lightweight editor out there. It takes a little to get acquainted with, but once you’ve used it for a little bit, your productivity skyrockets."
    }, {
      url:
        "https://www.calvinkinateder.com/blog/clifton",
      title: "CLIFTON 11/9/20",
      description:
        "Near-perfect conditions, mixed with a great model, made this shoot something special."
    }, {
      url:
        "https://www.calvinkinateder.com/blog/making-the-most-of-bad-conditions",
      title: "MAKING THE MOST OF BAD CONDITIONS – CBUS 11/21/2020",
      description:
        "Editing can really turn sub-optimal photos into ones that pop."
    }, 
    {
      title: "Columbus Commons First FPV Flight",
      description: "Maiden voyage with the new GoPro",
      url: "https://youtu.be/5Pc69W2ojAw",
    },
    {
      title: "Quarry FPV Wreck",
      description: "Power lines and propellers don't mix",
      url: "https://youtu.be/ojStkLbkYMI",
    },
    {
      title: "Griggs Reservoir FPV Flight",
      description: "Testing out a new location down by the river",
      url: "https://youtu.be/2iq3Da2LQI8",
    },
    {
      title: "Scioto Grove Race Course",
      description: "Went out to fly at Scioto Grove metro park expecting an empty field and found a course set up instead.",
      url: "https://youtu.be/ZfAB2n5cYh4",
    },
    {
      title: "Burnett Woods FPV Flight",
      description: "First Flight on the UC campus",
      url: "https://youtu.be/5Pc69W2ojAw",
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Videos",
  subtitle: emoji(
    "I LOVE TO CREATE THINGS AND SHARE THEM WITH THE WORLD."
  ),

  talks: [
    {
      title: "Columbus Commons First FPV Flight",
      subtitle: "Maiden voyage with the new GoPro",
      video_url: "https://youtu.be/5Pc69W2ojAw",
    },
    {
      title: "Quarry FPV Wreck",
      subtitle: "Power lines and propellers don't mix",
      video_url: "https://youtu.be/ojStkLbkYMI",
    },
    {
      title: "Griggs Reservoir FPV Flight",
      subtitle: "Testing out a new location down by the river",
      video_url: "https://youtu.be/2iq3Da2LQI8",
    },
    {
      title: "Scioto Grove Race Course",
      subtitle: "Went out to fly at Scioto Grove metro park expecting an empty field and found a course set up instead.",
      video_url: "https://youtu.be/ZfAB2n5cYh4",
    },
    {
      title: "Burnett Woods FPV Flight",
      subtitle: "First Flight on the UC campus",
      video_url: "https://youtu.be/5Pc69W2ojAw",
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My inbox is open for all.",
  number: "+1 (614) 902-0224",
  email_address: "calvinkinateder@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
